var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsConstructionClassificationService } from './construction-classification.service';
import { ItemBase } from '../../../../../models/item/item-base';
import { RequestQuery } from '../../../../../component/list/list.service';
var KtsConstructionClassificationLabelComponent = /** @class */ (function (_super) {
    __extends(KtsConstructionClassificationLabelComponent, _super);
    function KtsConstructionClassificationLabelComponent(service, baseService, constClassService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.constClassService = constClassService;
        _this.cols = [];
        return _this;
    }
    KtsConstructionClassificationLabelComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    KtsConstructionClassificationLabelComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        this.cols = [];
        var constClass = jsonpath.value(this.col, '$.params.classification.key');
        if (this.val[constClass]) {
            var option = this.constClassService.getOption(this.componentName, constClass);
            if (Object.keys(option).length > 0 && option.code.toString() === String(this.val[constClass])) {
                this.cols.push(this.getCol(constClass, [option]));
            }
            else {
                this.constClassService.getType('CONSTRUCTION_CLASSIFICATION').subscribe(function (options) {
                    _this.constClassService.setOption(_this.componentName, constClass, _this.val[constClass], options);
                    _this.cols.unshift(_this.getCol(constClass, options));
                });
            }
        }
        var constMiddleClass = jsonpath.value(this.col, '$.params.middleClassification.key');
        if (this.val[constClass] && this.val[constMiddleClass]) {
            this.cols.push(Object.assign(new ItemBase(), { controlType: 'label', label: ', ' }));
            var option = this.constClassService.getOption(this.componentName, constMiddleClass);
            if (Object.keys(option).length > 0 && option.code.toString() === String(this.val[constMiddleClass])) {
                this.cols.push(this.getCol(constMiddleClass, [option]));
            }
            else {
                this.constClassService.getType('CONSTRUCTION_MIDDLE_CLASSIFICATION', this.getQuery(this.val[constClass])).subscribe(function (options) {
                    _this.constClassService.setOption(_this.componentName, constMiddleClass, _this.val[constMiddleClass], options);
                    _this.cols.push(_this.getCol(constMiddleClass, options));
                });
            }
        }
    };
    KtsConstructionClassificationLabelComponent.prototype.getCol = function (key, options) {
        return Object.assign(new ItemBase(), { key: key, controlType: 'select', params: { options: options } });
    };
    KtsConstructionClassificationLabelComponent.prototype.getQuery = function (id) {
        return Object.assign(new RequestQuery(), {
            limit: '',
            offset: 0,
            predicateList: [{ name: 'construction_classification_m.id', value: id, operator: 'eq' }]
        });
    };
    KtsConstructionClassificationLabelComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-construction-classification-label',
                    template: '<ng-template ngFor let-c [ngForOf]="cols" let-idx="index"><column-formlabel [componentName]="componentName" [index]="index" [col]="c" [val]="val[c.key]" [msg]="msg"></column-formlabel></ng-template>'
                }] }
    ];
    /** @nocollapse */
    KtsConstructionClassificationLabelComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsConstructionClassificationService }
    ]; };
    return KtsConstructionClassificationLabelComponent;
}(ColumnBaseComponent));
export { KtsConstructionClassificationLabelComponent };
//# sourceMappingURL=construction-classification-label.component.js.map